// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-badge {
  position: relative !important;
  z-index: 100 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/modal-ranking/modal-ranking.component.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,uBAAA;AACF","sourcesContent":["ion-badge{\n  position: relative !important;\n  z-index: 100 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
